export default {
  "3cx": {
    url: process.env.VUE_APP_URL_3CX,
    domain: process.env.VUE_APP_URL_3CX,
  },
  buzz: {
    url: process.env.VUE_APP_URL_BUZZ,
    domain: process.env.VUE_APP_URL_BUZZ ? new URL(process.env.VUE_APP_URL_BUZZ).origin : null,
  },
  dash: {
    url: process.env.VUE_APP_URL_DASH,
    domain: process.env.VUE_APP_URL_DASH ? new URL(process.env.VUE_APP_URL_DASH).origin : null,
  },
  mapit: {
    url: process.env.VUE_APP_URL_MAPIT
      ? `${process.env.VUE_APP_URL_MAPIT}?passphrase=${process.env.VUE_APP_PASSPHRASE_MAPIT}&referrer=BOLT`
      : null,
    domain: process.env.VUE_APP_URL_MAPIT
      ? `${process.env.VUE_APP_URL_MAPIT}?passphrase=${process.env.VUE_APP_PASSPHRASE_MAPIT}&referrer=BOLT`
      : null,
    make: (url) =>
      process.env.VUE_APP_URL_MAPIT
        ? `${process.env.VUE_APP_URL_MAPIT}/${url}?passphrase=${process.env.VUE_APP_PASSPHRASE_MAPIT}&referrer=BOLT`
        : null,
  },
  mobileApp: {
    url: process.env.VUE_APP_URL_MOBILE,
    domain: process.env.VUE_APP_URL_MOBILE ? new URL(process.env.VUE_APP_URL_MOBILE).origin : null,
  },
  prospectr: {
    url: process.env.VUE_APP_URL_PROSPECTR,
    domain: process.env.VUE_APP_URL_PROSPECTR
      ? new URL(process.env.VUE_APP_URL_PROSPECTR).origin
      : null,
  },
  revuze: {
    url: process.env.VUE_APP_URL_REVUZE,
    domain: process.env.VUE_APP_URL_REVUZE ? new URL(process.env.VUE_APP_URL_REVUZE).origin : null,
  },
};
